module.exports = __webpack_public_path__ + "images/hnks.e6ee.png";